export default {
  sideMenu: {
    main: "main",
    home: "home",
    login: "login",
    authority_server:"Authentication",
    authority_management: "Authentication",
    user_management: "Member",
    organization_management: "Organization",
    resource_management: "Resource",
    role_management: "ResourceGroup",
  },
  common: {
    invalidForm:"Form Validation Failure",
    invalidPhone: "The mobile phone number format is incorrect",
    invalidVerifyCode: "The format of the verification code is incorrect",
    onlyone:"Failure Due to Duplicated Name",
    action:'Action',
    close:"close",
    cardType1: "Mainland identity card",
    cardType2: "Hong Kong Identity Card",
    cardType3: "Hong Kong Identity Card",
    cardType4: "Other documents/certificates",
    name: "name",
    ID: "ID",
    email: "Email",
    position: "Position",
    exportMemeber: "Export Member",
    exportResource: "Export Resource",
    addOrg: "Add Organization",
    orgList: "Organization List",
    place: "Area",
    forbid: "Forbidden",
    normal: "Normal",
    confirm: "Confirm",
    cancel: "Cancel",
    status: "Status",
   selectDate: "Select Date",
    inputKey: "Input ID/name to search",
    loginTitle: "Bank of China mall management platform",
    pleaseInput: "Please Input",
    pleaseSelect: "Please Select",
   query: "QUERY",
    add: "NEW",
    edit: "UPDATE",
    remove: "REMOVE",
    connectResourceGroup: "CONNECT RESOURCE GROUP",
    addOrgorPo: "Add Departments or Position",
    toTop: "On TOP",
     exportMember: "Export Member",
    uploadResource: "Upload Resource",
    resourceExport: "Export Resource",
    alert: "warn",
    connectResource: "Connect Resource",
    remark: "Remark",
    confirmEdit: "Confirm the updates?",
    myCollection:"My Favorites",
    addtoCollection:"Click to add in My Favorites", 
    myCollectionSetting:"My Favorites Setting",
    notice: "Announcement", 
    currentTime:"Current Time",
    collectedList:"Favorites Feature List",////已收藏的功能列表
    delete:"Remove",
    primaryDirectory:"Primary Directory ",
    functionName:"Feature Name",
    functionNameQuery:"Please input the feature name",////输入功能名称查询
    selectGrouptoAdd:"Please select the feature group you want to add",
    maxFunction:"The maximum of My Favorites can store up to N features",////我的收藏最多可以存放N个功能
    msg:"Message",
    confirmDelete:"Confirm to Delete?", 
    unrecoverable:"The operation is NOT recoverable.",////该操作不可恢复
    associatedPhone: "Associated mobile number",
    unbind: "Unassociated mobile number",
    queryPhone: "Query mobile phone number",
    addSuccess: "Add Success",
    index: "index",
    phoneRepeated: "The phone number cannot be repeated"
  },
  login: {
    org: "Institution",
    userName: "User Name",
    passwords: "Password",
    login: "Login",
    locked: "Locked",
    verifyCode: "Verify Code",
    getVerifyCode: "Send verification code",
    copyRight: "© copyright QCC Version：CAKU V1.00",
  },
  timeZone: "8",//时区
  message: {
    hello: "Study hard and make progress every day!",  
  },////好好学习，天天向上！
  authorization: {
    addMember: "Add Member",
    editMember: "Edit Member",
    addresource: "Add Resource",
    editresource: "Edit Resource",
    addresourceGroup: "Add Resource Group",
    editresourceGroup: "Edit Resource Group",
    addPhone: "Add Phone",
    member: {
       name: "Name",
      userId: "User ID",
      userName: "User Name",
      userKind: "User Kind",
      userRole: "User Role",
      lastUpdater: "Last Updater",
      lastUpdateTime: "last Update Time",
      rootOrgCode: "Root Organization Code",
      parentOrgCode: "Parent Organization Code",
      branchCode: "Branch Code",
      contactNo: "Contact No",
      email: "Email",
      positionCodes: "Position Codes",
      loginPwd: "Login Password",
      effectiveDate: "Effective Date",
      pwdExpDate: "Password ExpDate",
      addMemeberTitle: "Add Member",
      editMemeberTitle: "Edit Member",
      addTitle: "Add",
     connectResourceGroup: "Connect Resource Group",
      onlyChooseOne: "Only choose on item！",
      mustChooseOne: "Must choose on item！",
      loginId: "loginId",
      ID: "ID",
      job: "Position",
       basicInfo: "Basic Information",
      loginInfo: "Login Information",
      phoneInfo: "Phone Information",
      positionRule: "For multiple positions, use ',' as segmentation. Example:code1,code2,code3",////多个岗位时，用”,”分割。Eg:code1,code2,code3
      lengthRule: "Max length is 16",
      loginPwdRule: "To be added ",////待补充
      effectiveDateRule: "yyyy-MM-dd HH:mm:ss not earlier than Expire Date ",
      pwdExpDateRule: "yyyy-MM-dd HH:mm:ss",
    },
    organization: {
      code: "Code",
      type: "Type",
      department: "Department",
      organization: "Organization",
      positionType: "Position Type",
      position: "Position",
      phone: "Phone",
      orgCode: "Organization Code",
      engName: "English Name",
      chName: "Chinese Name",
      selectProvince: "Select Province",
      selectCity: "Select City",
      selectArea: "Select Area",
      placeDetail: "Detail Address",
      selectAddType: "Please select add type",
      positionCode: "Position Code",
      sequence: "Sequence",
      name: "Name",
      ID: "ID",
      email: "Email",
      confirmDelete1: "Confirm to delete?",////确认要进行删除操作吗，
      confirmDelete2: "The operation is NOT recoverable.",////该操作不可恢复
      selectResGroup: "Please select the resources group to be added",////请选择要新增的资源分组
      selectAddorInput: "Please select the Child Organization or position you want to add and enter the name below",////请选择要新增子组织或岗位并在下方输入名称
     childOrg: "Child Organization",
      inputAddOrg: "Please input organization name",
      inputOrg: "Please input organization name",
      connectedGroup: "Already associated with the resources group list",////已关联资源分组列表
      resGroupCode: "Resources group Code", ////资源分组编码
    },
    resource: {
      icon:"ICON",
      urlName: "URLName",
      module: "Module",
      group: "Group",
      menu: "Menu",
      button: "Button",
      dataAuth: "data Auth",
      urlAuth: "URL Auth",
      resCode: "Resource Code",
      onlyCodeRule:
        "The unique resources code must be start with a letter,  can be filled in number, letter and underline.(For example: resource_page_1)",////唯一资源编码，以字母开头，可以填写数字、字母、下划线（例如：resource_page_1）
      resName: "Resource Name",
      resNameCn: "Resource Chinese Name",
      belongSys: "Belong System",
      resType: "Resource Type",
      status: "Status",
      resSequence: "Sequence",
      resContent: "Resource Content",
      moduleText: "Module Text",
      urlList: "Connect URL",
      addResTitle: "Add Resource",
      editResTitle: "Edit Resource",
      area1: "Area 1",
      area2: "Area 2",
      upload: "Upload",
      uploadRule: "Only upload excel file",
      exportRes: "Export Resource",
    },
    resGroup: {
      connectRes: "Connect Resource",
      resGroupCode: "Resource Group Code",
      resGroupName: "Resource Group Name",
      resGroupNameCn: "Resource Group Chinese Name",
      belongSys: "Belong System",
      belongOrg: "Belong Organization",
      effectiveDate: "Effective Date",
      expDate: "Expire Date",
      name: "Name",
      addResGroup: "Add Resource Group",
      editResGroup: "Edit Resource Group",
      onlyConnect: "Only can connect one item",
    },
  },
  header: {
    switchLang: "switch language",
    myTable: "my table",
    center: "center",
    logout: "Logout",
    mainPage:"Main Page"
  },
  pages: {},
};
